module.exports = __webpack_public_path__ + "vue/img/suoxiao.6d2fec58.png";